import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import useDesignTokens from './useDesignTokens';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

var withDesignTokens = function withDesignTokens(Component, defaultTokens, definitionMap) {
  var WithDesignTokens = /*#__PURE__*/forwardRef(function (props, ref) {
    var tokens = useDesignTokens(props, defaultTokens, definitionMap); // eslint-disable-next-line @typescript-eslint/no-unused-vars

    var _tokens = props.tokens,
        rest = _objectWithoutProperties(props, _excluded);

    var UntypedComponent = Component;
    return _jsx(UntypedComponent, _objectSpread(_objectSpread({
      ref: ref
    }, rest), {}, {
      tokens: tokens
    }));
  });
  WithDesignTokens.displayName = "WithDesignTokens(".concat(Component.displayName, ")");
  return WithDesignTokens;
};

export default withDesignTokens;